import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import BrandMarquee from "@/components/BrandMarquee";
import ExploreSections from "@/components/ExploreSections";
import WorkWithUsSection from "@/components/WorkWithUsSection";
import ConversionBlock from "@/components/ConversionBlock";

export default function HomePage() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <BrandMarquee />
      <ExploreSections />
      <WorkWithUsSection />
      <ConversionBlock />
    </>
  );
}
